import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetTaskTemplates } from '@/shared/hooks/task/useGetTaskTemplates';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { listItemMsg } from '../../FormattedListValue';
import AutoComplete from '../select/AutoComplete';
/**
 * Task template select component specifically for the capacity report.
 * Filters task templates based on those that have scheduled work in the selected period.
 */
export var CapacityTaskSelect = function (_a) {
    var initialValue = _a.initialValue, placeholder = _a.placeholder, availableTemplateIds = _a.availableTemplateIds, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var data = useGetTaskTemplates().data;
    var taskTemplates = useMemo(function () {
        if (!data)
            return undefined;
        // Filter by available templates if provided
        var filtered = availableTemplateIds && availableTemplateIds.length > 0
            ? data.filter(function (item) { return availableTemplateIds.includes(item.id); })
            : data;
        return filtered
            .map(function (item) { return ({
            key: item.id,
            label: formatMessage(listItemMsg('taskTemplate', item.id, item.name)),
            resourceId: item.resourceId,
        }); })
            .sort(function (a, b) { return a.label.toLowerCase().localeCompare(b.label.toLowerCase()); });
    }, [data, availableTemplateIds, formatMessage]);
    var initialSelectedItem = useMemo(function () { var _a; return (_a = (initialValue && (taskTemplates === null || taskTemplates === void 0 ? void 0 : taskTemplates.find(function (item) { return (item === null || item === void 0 ? void 0 : item.key) === initialValue; })))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, taskTemplates]);
    var componentKey = useMemo(function () {
        if (!availableTemplateIds || availableTemplateIds.length === 0) {
            return 'all-templates';
        }
        // Create a stable key from sorted IDs
        return availableTemplateIds
            .slice()
            .sort()
            .join('-');
    }, [availableTemplateIds]);
    return (_jsx(AutoComplete, { items: taskTemplates, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: function (item) { return onChange(item === null || item === void 0 ? void 0 : item.key); } }, componentKey));
};
